import EVT from './event';
import DOM from './residential';
import ORG from './organization';

export default { EVT, DOM, ORG };
